import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CareConneRoomItem } from '@app/models/user.model';
import { RoomCategory } from '@app/shared/enum/care-conne.enum';
import { SettingSelectors } from '@app/store/setting/setting.selectors';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-room-item',
  templateUrl: './room-item.component.html',
  styleUrls: ['./room-item.component.scss']
})
export class RoomItemComponent implements OnInit, AfterViewInit {
  @ViewChild('roomNameEl') roomNameEl!: ElementRef<HTMLElement>;
  @Input() room!: CareConneRoomItem;
  @Input() isSelected: boolean = false;
  @Output() changeSelect = new EventEmitter<number>();

  roomName: string = '';
  roomType: string = '';
  isToolTip: boolean = false;

  get carePass() {
    return this.store.selectSnapshot(SettingSelectors.CareConnePass);
  }

  constructor(
    private store: Store,
    private cd: ChangeDetectorRef
  ) {
  }
  ngAfterViewInit(): void {
    if (!this.roomNameEl) return;
    const { scrollWidth, clientWidth } = this.roomNameEl.nativeElement;
    this.isToolTip = scrollWidth > clientWidth;
    this.cd.detectChanges();
  }

  ngOnInit(): void {
    this.roomName = this.room.name;
    this.roomType = this.groupTypeGen();
  }


  groupTypeGen() {
    const { type, userId, userInfo } = this.room;
    if (type === 3) {
      if (userId === this.carePass) {
        return RoomCategory.SELFCHAT;
      }
      return RoomCategory.YOURCHAT;
    }

    if (type === 1) {
      let multi: string[] = [];
      if (userInfo.some(info => info.roleId === 1))
        multi.push(RoomCategory.DAI);
      if (userInfo.some(info => info.roleId === 3))
        multi.push(RoomCategory.FAMILY);
      if (userInfo.some(info => info.roleId === 2))
        multi.push(RoomCategory.STAFF);
      if (userInfo.some(info => info.roleId === 4))
        multi.push(RoomCategory.EXTERNAL);
      return multi.join(',');
    }

    if ([2, 5, 6].includes(type)) {
      return RoomCategory.GROUP;
    }
    return '';

  }

  selectRoom(room: CareConneRoomItem) {
    this.changeSelect.emit(room.roomId);
  }

}
